import { render, staticRenderFns } from "./drawer-form.vue?vue&type=template&id=4bea82e2"
import script from "./drawer-form.vue?vue&type=script&setup=true&lang=js"
export * from "./drawer-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./drawer-form.vue?vue&type=style&index=0&id=4bea82e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports